// Size Attribute
export enum EKwikUIInputFileSize {
  S = "s",
  M = "m",
  L = "l"
}
export const VKwikUIInputFileSize = [
  EKwikUIInputFileSize.S,
  EKwikUIInputFileSize.M,
  EKwikUIInputFileSize.L
] as const;

export type TKwikUIInputFileSize = (typeof VKwikUIInputFileSize)[number];

// Variant Attribute
export enum EKwikUIInputFileVariant {
  NATIVE = "native",
  TAIGAUI = "taigaui"
}
export const VKwikUIInputFileVariant = [
  EKwikUIInputFileVariant.NATIVE,
  EKwikUIInputFileVariant.TAIGAUI
] as const;

export type TKwikUIInputFileVariant = (typeof VKwikUIInputFileVariant)[number];

// File State Attribute
export enum EKwikUIInputFileState {
  NORMAL = "NORMAL",
  ERROR = "ERROR",
  LOADING = "LOADING",
  DELETED = "DELETED"
}
export const VKwikUIInputFileState = [
  EKwikUIInputFileState.NORMAL,
  EKwikUIInputFileState.ERROR,
  EKwikUIInputFileState.LOADING,
  EKwikUIInputFileState.DELETED
] as const;

export type TEKwikUIInputFileState = (typeof VKwikUIInputFileState)[number];
